import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getFilteredSupplierFailureCodes(filter) {
            var meta = { clientApiMethod: 'getFilteredSupplierFailureCodes', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "SupplierFailureCode/Filtered", { params: filter }, meta)
            return response?.data;
        },
        async getSupplierFailureCodes() {
            var response = await client().get(store.state.apiRouteRoot + "SupplierFailureCode/getall", { meta: { clientApiMethod: 'getSupplierFailureCodes' } })
            return response?.data;
        },
        async getSupplierFailureCodesBySupplierId(supplierId) {
            var meta = { clientApiMethod: 'getSupplierFailureCodesBySupplierId', input: { supplierId: supplierId } }
            var response = await client().get(store.state.apiRouteRoot + "SupplierFailureCode/supplier/" + supplierId, { meta: meta })
            return response?.data;
        },
        async getSingleSupplierFailureCode(supplierFailureCodeId) {
            var meta = { clientApiMethod: 'getSingleSupplierFailureCode', input: { supplierFailureCodeId: supplierFailureCodeId } }
            var response = await client().get(store.state.apiRouteRoot + "SupplierFailureCode/get/" + supplierFailureCodeId, { meta: meta })
            return response?.data;
        },
        async createSupplierFailureCode(supplierFailureCode) {
            var meta = {
                clientApiMethod: 'changeSupplierFailureCode',
                input: { supplierFailureCode },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.supplier_failure_code.supplier_failure_code") })
            }
            const query =
                '?SupplierId=' + supplierFailureCode.SupplierId +
                '&Code=' + supplierFailureCode.Code +
                '&Description=' + supplierFailureCode.Description;
            var response = await client().put(store.state.apiRouteRoot + "SupplierFailureCode/add" + query, null, { meta: meta })
            return response?.data;
        },
        async changeSupplierFailureCode(supplierFailureCode) {
            var meta = {
                clientApiMethod: 'changeSupplierFailureCode',
                input: { supplierFailureCode },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.supplier_failure_code.supplier_failure_code") })
            }
            const query =
                '?Id=' + supplierFailureCode.Id +
                '&SupplierId=' + supplierFailureCode.SupplierId +
                '&Code=' + supplierFailureCode.Code +
                '&Description=' + supplierFailureCode.Description;
            var response = await client().patch(store.state.apiRouteRoot + "SupplierFailureCode/change/" + supplierFailureCode.Id + query, null, { meta: meta })
            return response?.data;
        },
        async removeSupplierFailureCode(supplierFailureCodeId) {
            var meta = {
                clientApiMethod: 'removeSupplierFailureCode',
                input: { supplierFailureCodeId: supplierFailureCodeId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.supplier_failure_code.supplier_failure_code") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "SupplierFailureCode/remove/" + supplierFailureCodeId, { meta: meta })
            return response?.data;
        },
    }
}